// extracted by mini-css-extract-plugin
export default {"footerBox":"footer_footerBox__QuZh3","footerUrl":"footer_footerUrl__0Z62F"};